import { render, staticRenderFns } from "./LegalMention.vue?vue&type=template&id=79cce859&scoped=true&"
import script from "./LegalMention.vue?vue&type=script&lang=js&"
export * from "./LegalMention.vue?vue&type=script&lang=js&"
import style0 from "./LegalMention.vue?vue&type=style&index=0&id=79cce859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cce859",
  null
  
)

export default component.exports